import { AxiosErrorResponse, Result, ApiError } from './types';

function createApiError(message: string, resultCode?: Result, statusCode?: number): ApiError {
  const err = new Error(message) as ApiError;
  err.resultCode = resultCode;
  err.statusCode = statusCode;
  return err;
}

export function createApiErrorFromAxiosError(error: AxiosErrorResponse): ApiError {
  // `error.response` is undefined if client has no internet connection
  if (!error.response) {
    return createApiError('There is no connectivity, please try again');
  }

  // NOTE: Although it's not reflected in types (it's hidden in Axios' types)
  // but when there's a network error like a gateway timeout
  // then `error.response.data` is equal to `null`.
  if (error.response.data) {
    // TODO: Remove as soon as api is fixed
    // NOTE: Temporary hack which transforms Result.Exception when you have logged out into
    // Result.NotAuthenticated for consistency in code which performs authentication checks
    if (
      error.response.data.result === Result.Exception &&
      error.response.data.systemErrorMessage === 'You have logged out.'
    ) {
      return createApiError('You have logged out', Result.NotAuthenticated, error.response.status);
    }

    // NOTE: `userMessage` is for user friendly error messages like validation ones
    // in cases when there're exceptions on the server we get a `null` value in it
    // and `systemErrorMessage` is filled instead
    // there's also `systemMessage` 🤔
    const errorMessage = error.response.data.userMessage || 'Unknown server error';
    return createApiError(errorMessage, error.response.data.result, error.response.status);
  }

  return createApiError(error.message, undefined, error.response.status);
}
